module.exports = __webpack_public_path__ + "img/07.ea16a700.jpg";